import { Component, OnInit } from '@angular/core';
import { InvoiceService } from '../invoice/invoice.service';
import { PoService } from '../po/po.service';
import { VendorService } from '../vendor/vendor.service';
import { ActivatedRoute, Params } from '@angular/router';
import { Location } from '@angular/common';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {

  dataSource: Object;
  
  invoices : any = [];
  data : any = [];
   graphdata : any = [];
  vendors : any = [];
  purchaseorder : any = [];

  constructor(
	private invoiceService :InvoiceService, 
	private spinnerService: Ng4LoadingSpinnerService, 
	private poservice : PoService, 
	private vendorservice : VendorService,  
	private route: ActivatedRoute) {
   }

   
  ngOnInit() {
	  
	  this.getRecentPurchaseOrder();
	  this.getRecentPaidInvoices();
	  this.getTopVendors();
	  this.getDashboardCounts();
	  this.GetDasboardgraphData();
  }
  
  
    getTopVendors() {

    return this.vendorservice.GetTopVendors()
               .subscribe(
                vendors => {
               
                  this.vendors = vendors
         
                 }
                );
 }
 
  getDashboardCounts() {
   
    return this.invoiceService.getDashboardCountsFinance()
               .subscribe(
                datalist => {                 
                  this.data = datalist[0];
         
                 }
                );
 }
 
 objectToArray(objArr, key) {
		var arr = [];
		for (var i = 0; i < objArr.length; i++) {
			arr.push(objArr[i][key]);
		}
		return arr;
	}

  GetDasboardgraphData() {
   
    return this.invoiceService.GetDasboardgraphData()
               .subscribe(
                datalist => {                 
                  this.graphdata = datalist;
				   console.log(this.graphdata);
				  // var labels = this.objectToArray(this.graphdata, 'FilterType');
			      // var data = this.objectToArray(this.graphdata, 'Amount');
				   this.dataSource = {
			  chart: {
				  "caption": "Histogram of expenses in last 6-7 months",
				  //"subCaption": "In MMbbl = One Million barrels",
				 // "xAxisName": "Country",
				  //"yAxisName": "Reserves (MMbbl)",
				  //"numberSuffix": "K",
				  //"theme": "fusion",
			  },
			  // Chart Data
			  "data": this.graphdata,
			  /*[{
				  "label": "January",
				  "value": "62"
			  },{
				  "label": "Feburary",
				  "value": "60"
			  },{
				  "label": "March",
				  "value": "80"
			  },{
				  "label": "April",
				  "value": "80"
			  },{
				  "label": "May",
				  "value": "56"
			  },{
				  "label": "June",
				  "value": "54"
			  }, {
				  "label": "July",
				  "value": "40"
			  }]
			  */
		  }; // end of this.dataSource
         
                 }
                );
 }
 
   getRecentPaidInvoices() {
   
    return this.invoiceService.GetRecentPaidInvoices()
               .subscribe(
                invoice => {                 
                  this.invoices = invoice;
         
                 }
                );
 }
 
   getRecentPurchaseOrder() {
   
    return this.poservice.GetRecentPurchaseOrders()
               .subscribe(
                purchaseorder => {                
                  this.purchaseorder = purchaseorder
         
                 }
                );
 }

}
